import React from 'react';

import { Box, Text } from '@mantine/core';
import { IconInfoSquare } from '@tabler/icons-react';
import KiloTooltip from 'components/KiloTooltip';

const ChangeHeader = (): JSX.Element => {
  return (
    <Box display='flex'>
      <Text>Utilization Rate</Text>{' '}
      <KiloTooltip
        multiline
        withinPortal
        position='bottom-end'
        withArrow
        label='The utilization rate represents the percentage of total available spots that were attended during the selected period.'
      >
        <IconInfoSquare size={16} style={{ cursor: 'help' }} />
      </KiloTooltip>
    </Box>
  );
};

export default ChangeHeader;
